import exifr from "exifr";

export const localYMD = (d) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

export async function photoDate(file) {
  if (file.type?.startsWith("image/")) {
    try {
      const meta = await exifr.parse(file, ["DateTimeOriginal", "CreateDate", "ModifyDate"]);
      const dt = meta?.DateTimeOriginal || meta?.CreateDate || meta?.ModifyDate;
      if (dt instanceof Date && !isNaN(dt)) return dt;
    } catch {
      // geen EXIF leesbaar
    }
    return null;
  }
  const lm = file.lastModified;
  if (lm && Date.now() - lm > 10 * 60 * 1000) return new Date(lm);
  return null;
}

export async function photoGps(file) {
  if (!file.type?.startsWith("image/")) return null;
  try {
    const g = await exifr.gps(file);
    if (g && Number.isFinite(g.latitude) && Number.isFinite(g.longitude)) return { lat: g.latitude, lon: g.longitude };
  } catch {
    // geen GPS-data
  }
  return null;
}
